/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CenterNoticeSearchResponseDto } from '../../models/center-notice-search-response-dto';

export interface ParentCenterNoticeControllerSearchCursor$Params {

/**
 * 페이지 크기
 */
  pageSize: number;

/**
 * 정렬 기준
 */
  orderBy?: string;

/**
 * 정렬 방향
 */
  align?: 'asc' | 'desc';

/**
 * 검색어
 */
  query?: string;

/**
 * 커서
 */
  cursor?: string;

/**
 * 센터 ID(센터에서 조회시)
 */
  centerId?: string;

/**
 * 아동 ID
 */
  childId?: string;
}

export function parentCenterNoticeControllerSearchCursor(http: HttpClient, rootUrl: string, params: ParentCenterNoticeControllerSearchCursor$Params, context?: HttpContext): Observable<StrictHttpResponse<CenterNoticeSearchResponseDto>> {
  const rb = new RequestBuilder(rootUrl, parentCenterNoticeControllerSearchCursor.PATH, 'get');
  if (params) {
    rb.query('pageSize', params.pageSize, {});
    rb.query('orderBy', params.orderBy, {});
    rb.query('align', params.align, {});
    rb.query('query', params.query, {});
    rb.query('cursor', params.cursor, {});
    rb.query('centerId', params.centerId, {});
    rb.query('childId', params.childId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CenterNoticeSearchResponseDto>;
    })
  );
}

parentCenterNoticeControllerSearchCursor.PATH = '/api/center-notice/parent/search/cursor';
